import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import { PersonOutlined, CheckCircleOutline } from "@mui/icons-material";

interface Props {
  currentTab: number;
  changeTab: (nextTab: number) => void;
  isCheckoutEnabled: boolean;
}

const muiStyle = {
  color: "#6a6d71",
  "&:hover": { color: "#6a6d71", backgroundColor: "#dfeaf6" },
  "&.Mui-selected": {
    color: "#6a6d71",
    backgroundColor: "#e6eef6",
  },
};

const VisitTopTabNavigation = (props: Props) => {
  const handleTopTabValueChange = (
    ev: React.SyntheticEvent<Element, Event>,
    newValue: number,
  ): void => {
    ev.preventDefault();
    props.changeTab(newValue);
  };

  return (
    <Paper
      elevation={3}
      sx={{
        width: "100%",
        position: "sticky",
        mt: -3,
        mb: 2,
      }}
    >
      <BottomNavigation
        showLabels={true}
        value={props.currentTab}
        onChange={(ev, newValue) => handleTopTabValueChange(ev, newValue)}
      >
        <BottomNavigationAction
          label={"Check-in"}
          icon={<PersonOutlined />}
          sx={muiStyle}
        />
        <BottomNavigationAction
          disabled={!props.isCheckoutEnabled}
          label={"Checkout"}
          icon={<CheckCircleOutline />}
          sx={muiStyle}
        />
      </BottomNavigation>
    </Paper>
  );
};
export default VisitTopTabNavigation;
